module.exports = __webpack_public_path__ + "static/img/tips.6f1c2b7c.jpg";